import {
  ChangeDetectionStrategy,
  Component,
  contentChildren,
  computed,
  inject,
} from '@angular/core';

import { NgTemplateOutlet } from '@angular/common';

import { ResponsivenessScreenDirective } from './responsiveness-screen.directive';
import { BreakpointMatch } from './domain/breakpoint-match';
import { BreakpointObserver } from '@angular/cdk/layout';
import { toSignal, toObservable } from '@angular/core/rxjs-interop';
import { distinctUntilChanged, map, switchMap } from 'rxjs';

@Component({
  selector: 'ps-responsiveness-screen',
  standalone: true,
  imports: [NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (activeTemplate(); as template) {
      <ng-container [ngTemplateOutlet]="template"></ng-container>
    } @else {
      <ng-content></ng-content>
    }
  `,
})
export class ResponsivenessScreenComponent {
  private readonly _breakpointObserver = inject(BreakpointObserver);

  private readonly _contentScreen = contentChildren(
    ResponsivenessScreenDirective,
  );

  private readonly _breakpoints = computed(() =>
    this._contentScreen().flatMap((screen) => screen.breakpoints()),
  );

  public readonly activeTemplate = toSignal(
    toObservable(this._breakpoints).pipe(
      switchMap((breakpoint) => this._breakpointObserver.observe(breakpoint)),
      map((matchState) => {
        if (!matchState?.matches) return null;
        const breakpoint = new BreakpointMatch(matchState);
        return (
          this._contentScreen()?.find((content) => content.match(breakpoint))
            ?.template ?? null
        );
      }),
      distinctUntilChanged(),
    ),
    { initialValue: null },
  );
}
